<template>
    <div>
        <el-form :model="filterData" ref="filterData" :inline="true" class="case-amount-dev">
            <el-row>
                <el-col :lg="8" :xl="6" :md="12" :sm="12" :xs="24">
                    <el-form-item style="display: grid;">
                        <el-select v-model="filterData.year" :placeholder="$t('Year')" @change="getUpdatedData" size="small" filterable>
                            <el-option v-for="year in years" :value="year" :key="year"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="6" :md="12" :sm="12" :xs="24">
                    <el-form-item style="display: grid;">
                        <el-select v-model="filterData.month" :placeholder="$t('Month')" @change="getUpdatedData" size="small" filterable clearable>
                            <el-option v-for="(month,monthNum) in months" :label="month" :value="(monthNum+1)" :key="month"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :xl="6" :md="10" :sm="12" :xs="24">
                    <el-form-item style="display: grid;">
                        <el-select :placeholder="$t('Select Organization')" :disabled="disableOrganization" v-model="filterData.organization_slug" @change="getAllFachstellen()" size="small" filterable clearable>
                            <el-option v-for="(item) in organizationList.data" :label="item.display_name" :key="item.slug" :value="item.slug"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="12" :xl="12" :md="14" :sm="12" :xs="24" v-if="fachstellenList.data">
                    <el-form-item style="display: grid;">
                        <el-select :placeholder="$t('Select Fachstellen')" filterable v-model="filterData.fachstellen_slug" @change="getUpdatedData" size="small" multiple collapse-tags>
                            <el-option v-for="(item) in fachstellenList.data" :label="item.display_name" :key="item.slug" :value="item.slug"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <bar-chart :chart-data="datacollection" :options="options"></bar-chart>
    </div>
</template>
<script>
    import BarChart from "../js/bar.js";
    import moment from 'moment';
    export default {
        props: {
            organizationList: Object
        },
        components: {
            BarChart
        },
        computed: {
            years() {
                const year = new Date().getFullYear()
                return Array.from({
                    length: year - 2009
                }, (value, index) => 2010 + index)
            },
            months() {
                return moment.months();
            }
        },
        data() {
            return {
                datacollection: {},
                options: null,
                filterData: {
                    year: new Date().getFullYear(),
                    organization_slug: (this.$store.state.config.user.organization_slug) ? this.$store.state.config.user.organization_slug : null,
                    fachstellen_slug: null
                },
                fachstellenList: {},
                disableOrganization: false
            }
        },
        mounted() {
            this.fillData();
            if(this.$store.state.config.user.organization_slug) {
                this.getAllFachstellen();
                this.disableOrganization = true;
            }
        },
        methods: {
            getAllFachstellen() {
                this.fillData();
                request({
                    url: "get-all-fachstellen",
                    method: "get",
                    params: {
                        organization_slug: this.filterData.organization_slug
                    }
                }).then(response => {
                    this.filterData.fachstellen_slug = [];
                    this.fachstellenList = response.data;
                });
            },
            getUpdatedData() {
                this.fillData();
            },
            fillData() {
                request({
                    url: "get-fachstellen-amount-cases-count",
                    method: "get",
                    params: this.filterData
                }).then(response => {
                    this.datacollection = response.data.data;
                });
                this.options = {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            display: true,
							position: 'left',
							id: 'y-axis-1',
                            ticks: {
                                padding: 15,
                                beginAtZero: true
                            },
                            gridLines: {
                                drawTicks: false,
                            }
                        },{
                            display: true,
							position: 'right',
							id: 'y-axis-2',
                            ticks: {
                                padding: 15,
                                beginAtZero: true,
                                precision: 0
                            },
                            gridLines: {
                                drawTicks: false,
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                padding: 15,
                                autoSkip: false,
                                maxRotation: 90,
                                minRotation: 90
                            },
                            gridLines: {
                                drawTicks: false,
                            }
                        }]
                    },
                    hover: {
                        mode: null
                    },
                }
            }
        },
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/Widgets/chart/components/FachstellenAmountCases.vue